<template>
  <!--  <el-input-number v-model="input" @change="currentSel" :width="options.width"
    :placeholder="options.placeholder" :min="options.min" :max="options.max" :precision="options.precision"
    :prepend="options.prepend" :append="options.append" :step="options.step" :disabled="options.disabled"></el-input-number> -->
  <van-field v-model="input" type="number" @input="currentSel" :label="dModel.label" :placeholder="options.placeholder"
    :maxlength="options.maxlength" :rules="dModel.rules" />
</template>

<script>
  import formDesignMixins from './mixins/formDesignMixins'
  export default {
    name: "DesignInputNumber",
    data() {
      return {
        input: "",
      };
    },
    mixins: [formDesignMixins],
    props: {
      value: {
        // type: Number,
      },
      options: {
        type: Object,
        default: function() {
          return {
            width: "100%", // 宽度
            defaultValue: 0, // 默认值
            min: 0, // 可输入最小值
            max: 100, // 可输入最大值
            precision: null,
            tooptip: '', // 提示
            prepend: '', // 前缀
            append: '', // 后缀
            step: 1, // 步长，点击加减按钮时候，加减多少
            hidden: false, // 是否隐藏，false显示，true隐藏
            disabled: false, //是否禁用
            placeholder: "请输入"
          }
        }
      }
    },
    methods: {
      currentSel: function(selVal) {
        this.$emit("input", selVal);
      },
    },
    watch: {
      value(nv) {
           console.log(this.value);
        if (nv) {
          this.input = parseInt(nv);
        }
      },
    },
    mounted: function() {
      console.log(this.value);
      if (this.value) {
        this.input = parseInt(this.value);
      }

    },
  };
</script>

<style scoped="scoped">

</style>
